var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"otherContainer"},[_c('Presentational',{attrs:{"others":_vm.others},on:{"update":function (other) {
        _vm.updateOther(other);
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }